import { View } from 'foundations-components/components/View';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { List } from 'foundations-components/transitional/components/List';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import styled from 'styled-components';
import { LISTBOX_ID } from '../constants';
import { getOptionId } from './SearchBar';
import { SearchOption } from './SearchOption';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledListItem = styled.li.withConfig({
  displayName: "SearchDropdown__StyledListItem",
  componentId: "x5k4zr-0"
})(({
  theme: _theme,
  isActive
}) => {
  const theme = _theme;
  return {
    cursor: 'pointer',
    padding: theme.space['250'],
    backgroundColor: isActive ? theme.color['temp-do-not-use-fill-field-hover'] : undefined,
    '&:hover': {
      backgroundColor: theme.color['temp-do-not-use-fill-field-hover']
    }
  };
});
export function SearchDropdown({
  activeIndex,
  error,
  onResultSelect,
  options,
  searchTerm,
  setActiveIndex
}) {
  return /*#__PURE__*/_jsxs(View, {
    backgroundColor: "fill-surface-default",
    blockSize: !options ? '300px' : 'auto',
    borderRadius: "200",
    boxShadow: "400",
    insetInlineEnd: '0',
    insetInlineStart: '0',
    listStyleType: "none",
    marginBlockStart: "100",
    maxBlockSize: "300px",
    overflowY: "auto",
    position: "absolute",
    zIndex: "300",
    children: [!options && !error && /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest"
    }), /*#__PURE__*/_jsx(List, {
      "data-test-id": "search-results-list",
      role: "listbox",
      id: LISTBOX_ID,
      children: options.map((item, index) => /*#__PURE__*/_jsx(StyledListItem, {
        "aria-selected": activeIndex === index,
        id: getOptionId(index),
        isActive: activeIndex === index,
        onMouseEnter: () => setActiveIndex(index),
        role: "option",
        tabIndex: -1,
        children: /*#__PURE__*/_jsx(SearchOption, {
          item: item,
          onResultSelect: onResultSelect,
          searchTerm: searchTerm
        })
      }, `option-${index}`))
    })]
  });
}